import React from "react";
import { Typography as Typo } from "@material-ui/core";
import "./Typography.scss";
import TypoProps from "./Typography.types";

const Typography = (props: TypoProps) => {
  return <Typo {...props} className="typography--wrapper" />;
};

export default Typography;
